import { atom } from 'jotai';

export const isFilterAIAwaitingResponseEnabled = atom<boolean>(false);
